import clsx from 'clsx'
import type { PropsWithChildren } from 'react'

import s from './Chip.module.css'

interface ChipProps extends PropsWithChildren {
  active?: boolean
  onClick: () => void
  /** Цвет метки-квадратика слева (CSS-значение). */
  color?: string
  count?: number
}

export function Chip({ active, onClick, color, count, children }: ChipProps) {
  return (
    <button
      type="button"
      className={clsx(s.chip, active && s.active)}
      onClick={onClick}
      aria-pressed={active}
    >
      {color && <i className={s.dot} style={{ background: color }} />}
      {children}
      {count !== undefined && <span className={s.count}>{count}</span>}
    </button>
  )
}
